import { render, staticRenderFns } from "./OrderingList.vue?vue&type=template&id=0ff80b7a&"
import script from "./OrderingList.vue?vue&type=script&lang=js&"
export * from "./OrderingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports